import {LicenseInfo} from '@mui/x-license';
import type React from "react";

LicenseInfo.setLicenseKey('81a5077e09afa79e983f36038997a8eeTz0xMzM1MTYsRT0xODIyNTIxNTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y');

// This component ensures the license key is set as early as possible
export const MuiXLicense: React.FC = () => null
